<template>
  <section>
    <section class="py-4" v-if="!isLineLoggedIn">
      <div class="row">
        <div class="col-12 col-lg-6">
          <h2 class="mb-0 pb-3 special-title">{{ $t('message.home.specialty_services') }}</h2>
          <div class="form-group text-small">
            <h3>{{ $t('message.service_request.big_cleaning_building_require_province') }}</h3>
            <select class="form-control" v-model="provinceId" @change="loadExperiences">
              <option :value="null">{{ $t('message.experience.all_provinces') }}</option>
              <template v-for="(city, index) in globalState.cities">
                <option :key="index" v-if="city.id > 0" :value="city.id">{{ city | multiLangName }}</option>
              </template>
            </select>
          </div>
          <!-- Service categories -->
          <div class="pb-3">
            <div class="btn badge-pill btn-sm px-3 mr-2 mb-2"
                 v-for="service in globalState.services"
                 :class="[ service.id === serviceId ? 'btn-dark' : 'btn-light' ]"
                 v-if="service.parent_id === 0 && service.is_special_service === 1 && service.is_hidden === 0"
                 @click="searchExperiences({ service_id: service.id })">
              {{ service | multiLangName }}
            </div>
          </div>
        </div>
        <div class="col-lg-6" v-if="serviceId === 15">
          <div class="embed-responsive embed-responsive-16by9 rounded-all">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/y86t4yLYgdY" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
          <div class="pt-3">
            <h3>{{ $t('message.home.dust_mites_cleaning_title') }}</h3>
            <p>{{ $t('message.home.book_dust_mites_cleaning') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Section Thai Massage Professionals -->
    <section>
      <div class="row pt-3">
        <div class="col-12">
          <div v-if="serviceId">
            <h2 class="mb-1">
              <span v-html="$options.filters.serviceParentName(serviceId, globalState.services)"></span>
            </h2>
          </div>
          <label>{{ $t('message.experience.search_results', { count: experiences.length }) }}</label>
        </div>
      </div>
      <div class="row" v-if="experiences.length > 0">
        <div class="col-lg-4 col-sm-6 col-12" v-for="experience, index in experiences" :key="index">
          <experience :experience="experience" :displayCost="true" />
        </div>
      </div>
      <div v-else>
        <div class="text-center py-4">
          <label>ไม่พบข้อมูล</label>
        </div>
      </div>

    </section>
    <div class="d-flex justify-content-center m-5" v-if="experiences.length > 0">
      <b-pagination v-model="currentPage"
                    pills
                    :total-rows="pageCount"
                    :per-page="limit"
                    @page-click="handleClickPage">
        <template #page="{ page, active }">
          <b v-if="active" class="active-button-beneat">{{ page }}</b>
          <i v-else>{{ page }}</i>
        </template>
      </b-pagination>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import axios from 'axios'
  import Experience from './Experience'
  import userEventLogHelpers from '../../helpers/userEventLogHelpers'
  import insiderHelpers from '../../helpers/insiderHelpers'

  export default {
    components: {
      Experience
    },
    data () {
      return {
        page: 0,
        limit: 10,
        serviceId: 0,
        provinceId: null,
        serviceTitle: null,
        serviceDetail: null,
        bgClass: null,
        currentPage: 1,
        isLoading: false,
        experiences: [],
        pageCount: 0
      }
    },
    computed: {
      ...mapState('auth', ['isLineLoggedIn']),
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      handleClickPage (bvEvent, newPage) {
        console.log('bvEvent', bvEvent, newPage)
        this.page = newPage - 1
        this.loadExperiences()
      },
      searchExperiences (params) {
        if (this.serviceId === params.service_id) {
          this.serviceId = 0
        } else {
          this.serviceId = params.service_id
        }
        this.loadExperiences()
      },
      async loadExperiences () {
        const queryData = {
          page: this.page,
          limit: this.limit,
          service_id: this.serviceId,
          province_id: this.provinceId
        }
        const url = '/experiences'
        const {data} = await axios.get(url, { params: queryData })
        if (!data.error) {
          this.experiences = data.experiences
          this.pageCount = data.page_count
        } else {
          if (!queryData.page) {
            this.experiences = []
          }
        }
      },
      checkService () {
        switch (this.serviceId) {
          case 7:
            this.bgClass = 'section-thai-massage-professional'
            this.serviceTitle = this.$i18n.t('message.home.thai_massage_experience_title')
            this.serviceDetail = this.$i18n.t('message.home.book_therapist')
            break
          case 15:
            this.bgClass = 'section-dust-mites-cleaning'
            this.serviceTitle = this.$i18n.t('message.home.dust_mites_cleaning_title')
            this.serviceDetail = this.$i18n.t('message.home.book_dust_mites_cleaning')
            break
          case 22:
            this.bgClass = 'section-yoga'
            this.serviceTitle = this.$i18n.t('message.home.yoga_title')
            this.serviceDetail = this.$i18n.t('message.home.book_yoga')
            break
          case 24:
            this.bgClass = 'section-disinfectant-cleaning'
            this.serviceTitle = this.$i18n.t('message.home.disinfectant_cleaning_title')
            this.serviceDetail = this.$i18n.t('message.home.book_disinfectant_cleaning')
            break
        }
      },
      getBackgroundImage (experience) {
        const bgImage = 'background-image: url("' + experience.cover_photo + '");'
        return bgImage
      }
    },
    mounted () {
      this.serviceId = (this.$route.query.service_id) ? Number(this.$route.query.service_id) : 0
      this.checkService()
      this.loadExperiences()
      // Save user event log
      userEventLogHelpers.logEvent('view_experience_list', {
        service_id: this.serviceId
      })
      // Insider category page view event
      insiderHelpers.categoryPageViewEvent(this.user, ['Services', 'Special Services'])
    }
  }
</script>
<style scoped lang="scss">
  .pagination {
    margin: 2px 0;
    white-space: nowrap;
  }

  .btn-light {
    background-color: #E0E0E0;
  }

  .special-title::after {
    content: "";
    display: block;
    height: 0.25rem;
    width: 60px;
    left: 0;
    margin: 0;
    background: #00ACC1;
    border-radius: 999px;
    margin-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/experience/Index.vue